import { RoundupTypeEnum } from '@repo/supergraph/base/enums';
import type { MobileOrDesktop } from '@repo/utils/deviceType/types';
import { FeatureFlagName } from './constants';
import { isFeatureEnabled } from './utils';

export const getIsSeoBankingFFActive = (roundupType: RoundupTypeEnum, slug: string) =>
  isFeatureEnabled({
    feature: FeatureFlagName.seoBankingRoundupRank,
    slug,
    pageType: roundupType,
  });

export const getIsCdRatesRoundupRedesignActive = (slug: string) =>
  isFeatureEnabled({
    feature: FeatureFlagName.cdRatesRoundupRedesign,
    slug,
  });

export const getIsProductionalizeMobileFirstSummaryTableActive = (slug: string) =>
  isFeatureEnabled({
    feature: FeatureFlagName.productionalizeMobileFirstSummaryTable,
    slug,
  });

export const getIsHysaCalculatorActive = (slug: string) =>
  isFeatureEnabled({
    feature: FeatureFlagName.hysaCalculator,
    slug,
  });

export const getIsHysaVsNationalAvgBannerActive = (slug: string, deviceType: MobileOrDesktop) =>
  isFeatureEnabled({
    deviceType,
    feature: FeatureFlagName.hysaVsNationalAvgBanner,
    slug,
  });

export const getIsShowLessMonetizingOffersActive = (slug: string, deviceType?: MobileOrDesktop) =>
  isFeatureEnabled({
    deviceType,
    feature: FeatureFlagName.showLessMonetizingOffers,
    slug,
  });
export const getShowSevenOffersInSummaryTableActive = (slug: string) =>
  isFeatureEnabled({
    feature: FeatureFlagName.showSevenOffersInSummaryTable,
    slug,
  });

export const getIsAPYInPaidRoundupTitleActive = (slug: string) =>
  isFeatureEnabled({
    feature: FeatureFlagName.apyInPaidRoundupTitle,
    slug,
  });
